import * as _ from "lodash"
import * as am4charts from "@amcharts/amcharts4/charts"
import {calculateChangeRatePercent} from "@/ui/chart/calculateChangeRatePercent"
import {getArrow} from "@/ui/chartTheme"
import {LegendDataItem} from "@amcharts/amcharts4/charts"
import {dimensionSettings} from "@/cube/settings"
import {Dimension} from "@/cube"

export function createChangeRateLabel(
  dimension: string,
  value: string,
  change: {value: number; unit: string}
): string {
  const isDownPositive =
    dimensionSettings(<Dimension>dimension, value).isDownPositive ?? false
  const {symbol, color: arrowColor} = getArrow(change.value, isDownPositive)

  const svgIcon = `<svg aria-hidden="true" 
                        role="presentation" 
                        focusable="false" 
                        viewBox="0 0 24 24" 
                        class="-chart-arrow-icon notranslate" 
                        style="color: ${arrowColor};"
                        >
                     <path d="${symbol}"></path>
                    </svg>`

  return ` ${svgIcon}<span style="font-size: .95em; color: var(--semi-muted-color)">${Math.abs(
    change.value
  )}${change.unit}</span>`
}

export function updateChangeRate(
  chart: am4charts.XYChart,
  start: Date,
  end: Date,
  dimension: Dimension,
  isPercentualView: boolean
): void {
  // TODO improve this - can find the position of the values and reuse them
  for (const yAxis of chart.yAxes.values) {
    console.log("Y-axis", yAxis.series.values)
    for (const ySeries of yAxis.series.values) {
      console.log("Y-VALUES", ySeries.dataItems.values)
      const dataItemStart = ySeries.dataItems.values.find(
        value => value.dateX.getTime() === start.getTime()
      )

      const dataItemEnd = ySeries.dataItems.values.find(
        value => value.dateX.getTime() === end.getTime()
      )

      console.log("dataItemEnd", dataItemEnd)
      console.log("dataItemStart", dataItemStart)

      const change = isPercentualView
        ? {
            unit: "pp",
            value: _.round(
              dataItemEnd!.values.valueY.totalPercent -
                dataItemStart!.values.valueY.totalPercent,
              1
            ),
          }
        : {
            unit: "%",
            value: calculateChangeRatePercent(
              dataItemEnd!.valueY,
              dataItemStart!.valueY
            ),
          }

      // Hidden legend e.g. None might be null
      const legendDataItem = <LegendDataItem | null>ySeries.legendDataItem

      if (legendDataItem) {
        legendDataItem.label.html = `{name}${createChangeRateLabel(
          dimension,
          ySeries.name,
          change
        )}`
      }

      ySeries.updateLegendValue()

      console.log("Series chart.series.values", dataItemStart!.valueY)
    }
  }
}
